import styled from 'styled-components';
import { spacer } from 'theme';
import { CheckList } from '../CheckList';

export const StyledPrivacyBlockCheckList = styled(CheckList)`
  display: flex;
  flex-direction: column;
  gap: ${spacer(150)};
`;
